<template>
  <div>
    <div class="secondary" style="height: 4px"></div>
    <v-container>
      <v-row align="center">
        <v-col class="hidden-sm-and-down" md="6">
          <v-img
            max-height="300"
            contain
            src="https://kuzee.x10spin.com/uploads/loy/templatesettings/58bd616810834.png"
          >
          </v-img>
        </v-col>
        <v-col xl="5" md="6">
          <div class="headline">
            {{ this.$organization.loyalty_template_settings.login_teaser }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="secondary" style="height: 4px"></div>
    <v-container class="mt-6">
      <v-row>
        <v-col md="6" offset-md="3" cols="12">
          <Form></Form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Form from "./components/Form";
export default {
  name: "Login",
  components: { Form },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
